<template>
    <div class="loading-indicator text-right" :id="bubbleId">
        Your media is uploading... Please wait.
    </div>
</template>

<script>
import { scrollToLastMessage } from '@helpers/helpers';

export default {
    data() {
        return {
            bubbleId: 'loading-indicator',
        };
    },
    mounted() {
        setTimeout(
            this.scrollToLastMessage(
                document.getElementById(this.bubbleId),
                document.querySelector('.js-scroller'),
            ),
            300,
        );
    },
    methods: {
        scrollToLastMessage,
    },
};
</script>
